import React, {useEffect, useState} from "react";
import ProfileHeader from "../Headers/ProfileHeader";
import {getPrompt, postPrompt} from "../../lib/api";
import {FormControl} from "react-bootstrap";
import {Link} from "react-router-dom";

export function CustomizeAi(props: { cognitoUser: any }) {
  const {cognitoUser} = props;
  const [prompt, setPrompt] = useState('');
  const [message, setMessage] = useState('');
  const [enabled, setEnabled] = useState(true);

  useEffect(fetchPrompt, []);

  function fetchPrompt() {
    getPrompt().then(response => {
      if (response.ok) {
        response.json().then(json => {
          setPrompt(json.prompt.text);
        });
      }
    })
  }

  function savePrompt() {
    setMessage('');
    setEnabled(false)
    postPrompt(prompt).then(response => {
      if (response.ok) {
        setMessage('Saved!');
      } else {
        setMessage('There was an error saving, please try again');
      }
      setTimeout(()=> {setMessage('')}, 2000);
      setEnabled(true);
    })
  }

  return (<>
    <ProfileHeader cognitoUser={cognitoUser} title="Customize AI" linkToHome="/home"/>
    <section className="container main p-4 rounded">
      <div className="row">
        <div className="col">
          <h5>You can paste up to 16,000 characters of text here to customize how your AI assistant responds. If you want to customize how your AI Assistant responds in a particular Villa you can <Link to="/" className="orange">Click here</Link> and select any Villa and you can enter text into the Customize AI field there.</h5>
          <FormControl
            type="text"
            value={prompt}
            maxLength={16000}
            onChange={(event: any) => setPrompt(event.target.value)}
            placeholder="Enter text here to customize AI"
            aria-label="Customize AI"
            as="textarea"
            autoFocus
            rows={20}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <button className="mt-2 btn btn-primary" disabled={!enabled} onClick={savePrompt}>Save</button>
          <span className="ml-2">{message}</span>
        </div>
      </div>
    </section>
  </>);
}
